import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import './index.css'

Sentry.init({
  dsn: 'https://5ba8dc944e484585bf2c4f90d461b0ae@o1071304.ingest.sentry.io/6102718',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
})

ReactDOM.render(<App />, document.getElementById('root'))

registerServiceWorker()
